import { Component, Input, OnInit } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import SlotService from '../../cart-process/slot.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { IOrderSummary } from '../../interfaces/order-summary.interface';
import {
  PosPrecartPickupService
} from '../../customer-form/delivery-and-payment/delivery-mode/pos/pos-precart-pickup.service';
import { IPrice, ISummaryPrice } from '../../interfaces/cart-details.interface';
import { PriceTypeEnum } from '../../models/cartDetails/priceType.model';

@Component({
  selector: '[order-summary-receiver]',
  templateUrl: './order-summary-receiver.component.html',
})
export class OrderSummaryReceiverComponent implements OnInit {
  @Input() isVirginBrand: boolean;
  @Input() set orderData(orderData: IOrderSummary.Root) {
    this.updateOrderData(orderData);
  }

  public showPosSection = false;
  public showPayment: boolean;
  public orderId: number;
  public receiver: string;
  public deliveryAddress: IOrderSummary.DeliveryAddress;
  public paymentModeName: string;
  public cashOnDeliveryValue: string;
  public pointOfServiceData: IOrderSummary.PointOfServiceData;
  public posOpeningSchedule: string;
  public eidChoosen: boolean;
  public isMIDIdentityConfirmation: boolean;
  public deliveryCost: IPrice;

  constructor(
    protected commonInfo: CommonInfoService,
    private slotService: SlotService,
    private notificationProvider: NotificationProviderService,
    private posPrecartPickupService: PosPrecartPickupService,
  ) {
  }

  ngOnInit(): void {
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.updateProcess();
      }
    });

    this.getSessionStorageData();
  }

  private updateOrderData(orderData: IOrderSummary.Root): void {
    this.orderId = orderData.crmdOrderId;
    this.receiver = orderData.receiver;
    this.deliveryAddress = orderData.deliveryAddress;
    this.paymentModeName = orderData.paymentModeName;
    this.eidChoosen = orderData.eidChoosen;
    this.deliveryCost = orderData.deliveryCost;

    if (orderData.pointOfServiceData) {
      this.showPosSection = true;
      this.pointOfServiceData = orderData.pointOfServiceData;
      this.posOpeningSchedule = this.pointOfServiceData.openingSchedule?.replace(/\,/g, '<br>').toLowerCase();

      this.posPrecartPickupService.initialMap({
        lat: this.pointOfServiceData.lat,
        lng: this.pointOfServiceData.lng
      }, this.pointOfServiceData?.icon
        ? this.pointOfServiceData.icon
        : window['themeResourcePath'] + '/images/maps/marker-default.png').then();
    }

    this.updateProcess();
  }

  private updateProcess(): void {
    if (this.commonInfo && this.deliveryCost) {
      this.cashOnDeliveryValue = this.getCashOnDeliveryValue(this.commonInfo.summaryPrices, this.deliveryCost, this.commonInfo.taxName);

      this.showPayment = this.cashOnDeliveryValue && !(this.slotService.hasLeasing() && this.cashOnDeliveryValue === '0.00');
    }
  }

  private getSessionStorageData(): void {
    let formInputData = JSON.parse(sessionStorage.getItem('formInputData'));

    if (formInputData && typeof formInputData === 'string') {
      formInputData = JSON.parse(formInputData);
    }

    this.isMIDIdentityConfirmation = formInputData?.find(item => item.name === 'idCardType')?.value === 'M_ID_CARD';
  }

  private getCashOnDeliveryValue(summaryPrices: ISummaryPrice[], deliveryCost: IPrice, taxName: string): string {
    const payNowPrice = summaryPrices.find((priceGroup: any) => priceGroup.type === PriceTypeEnum.PAY_NOW);
    const finalPrice = +payNowPrice?.prices[0].price[taxName] + +deliveryCost[taxName];

    return finalPrice ? `${finalPrice.toFixed(2)}` : null;
  }

  getDeliveryAddressString(): string {
    const postalCode = this.deliveryAddress.postalCode ? this.deliveryAddress.postalCode : '';
    const town = this.deliveryAddress.town ? this.deliveryAddress.town : '';
    const province = this.deliveryAddress.province ? `, woj. ${this.deliveryAddress.province}` : '';

    return `${postalCode} ${town}${province}`;
  }
}
